import { GET_TOKEN, SET_TOKEN } from "redux/TypeConstant"

const TokenReducer=(state=localStorage.getItem('Token'),action)=>{
    switch(action.type)
    {
        case SET_TOKEN:
        return state = action.data

        case GET_TOKEN:
            return state 

            default :
            return state
    }

}

export default TokenReducer